var map = {
	"./sampang/Content.js": [
		3093,
		[
			613,
			229,
			738
		]
	],
	"./sampanganimation/Content.js": [
		6717,
		[
			613,
			229,
			650,
			235,
			768,
			54,
			653,
			861
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6690;
module.exports = webpackAsyncContext;